<div class="card">
  <img [src]="eventInfo?.url" alt="">
</div>
